import React from 'react'
import {Button, Row, Col, Glyphicon, FormControl} from 'react-bootstrap'
import AscComponent from '../../components/AscComponent'
import CommonTable from '../../containers/Elements/Table/CommonTable'
import OutboundRejectModal from './OutboundRejectModal'
import * as GlobalConst from "../../components/AscConstants";
import AscConfirm from '../../components/Modal/AscConfirm';

export default class OutboundReject extends AscComponent {
    constructor(props) {
        super(props)
        this.state = {
            // table item
            columns:          this.getColumnsData(),
            data:             [],
            filtered: [],
            pages:            null,
            loading:          false,

            // modal item
            show:             false,
            modalType:        null,
            errorMessageModalShow: false,
            errText:          "",

            // select item
            companySelect:    [],
            departmentSelect: [],
            floorSelect: [],

            // data item
            outbound_reject_id:  '',
            company_id:          '',
            company_name:        '',
            department_id:       '',
            department_name:     '',
            department_prefix:   '',
            floor_id:            '',
            floor_name:          '',
            all_department_flag: false,
            telno:               '',
            memo:                '',
            csv_outbound_reject: [],
            csv_header:          '',
            csv_line:             0,
            // button_disabled
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load" : [],
                "floor_load" : []
            },

            // 追加確認ポップアップ関連
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: '',
            confirmValue: null,
            confirmationMessage: null,

            
        }
        this.floor_load_flag = false;
    }

    componentDidMount = async () => {
        // 追加確認ポップアップ表示の対象画面であるか
        try {
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        }catch(err){
            console.log(err);
            this.showErrorObjectMesssage(err);
        }
    }

    getColumnsData() {
        let itemArr = [];

        itemArr.push({
            Header: this.props.langText.Body.Id,
            accessor: 'id',
            filterable: false,
            width: this.props.boardWidth.id,
        });

        // oem以上は会社カラム表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: 'cm12_companies.company_name',
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm12_companies.company_name")} />
            });
        }

        // 「全拠点」の表示もあるため拠点カラムは残す
        itemArr.push({
            Header: this.props.langText.Body.DepartmentName,
            accessor: 'cm13_departments.department_name',
            width: this.props.boardWidth.smedium,
            Cell: data => {
                let str =
                    (data.row._original.all_department_flag === 'Y')
                        ?
                        this.props.langText.Body.AllDepartment
                        :
                        data.row._original.cm13_departments.department_name

                return (
                    <div>{str}</div>
                )
            },
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.department_name")} />
        });

        if (((this.props.systemParameters.SYSTEM_FLOOR_FLG && this.props.systemParameters.SYSTEM_FLOOR_FLG === "Y") &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system)) || this.props.userInfo.floor_flg
        ) {
            // 「全フロア」の表示もあるので範囲で絞らない
            itemArr.push({
                Header: this.props.langText.Body.FloorName,
                accessor: 'cm13_departments.floor_name',
                width: this.props.boardWidth.smedium,
                Cell: data => {
                    let str =
                        (data.row._original.all_department_flag === 'Y')
                        ?
                        this.props.langText.Body.AllFloor
                        :
                        data.row._original.cm13_departments.floor_name

                    return (
                        <div>{str}</div>
                    )
                },
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.floor_name")} />
            });
        }

        itemArr.push({
            Header: this.props.langText.Body.OutboundRejectRule,
            accessor: 'telno',
            width: this.props.boardWidth.CallNumber,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "telno")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.Memo,
            accessor: 'memo',
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "memo")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.EntryUserName,
            accessor: 'entry_user_name',
            width: this.props.boardWidth.UserName,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "entry_user_name")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.Created,
            accessor: 'created',
            width: this.props.boardWidth.Date,
            Cell: ({value}) => value ? this.getMomentTime({format: this.props.langText.Body.DateFormat, date: value}) : "",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "created")} />,
            filterable: false,
        });

        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.Control,
            Cell: data => {
                // 権限に応じて各アイコン表示
                let rowData = [];
                // 編集権限あれば編集ボタン、編集権限無ければ閲覧ボタン
                if (this.props.currentPermission.edit) {
                        rowData.push(
                            <Button
                                key={0}
                                bsSize='xsmall'
                                onClick={this.modalShow('update', data.row._original)}
                                className='control-button'
                            >
                                <Glyphicon glyph='pencil'/>
                            </Button>
                        )
                } else {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize='xsmall'
                            onClick={this.modalShow('read', data.row._original)}
                            className='control-button'
                        >
                            <Glyphicon glyph='eye-open'/>
                        </Button>
                    )
                }
                if (this.props.currentPermission.delete) {
                        rowData.push(
                            <Button
                                key={2}
                                bsSize='xsmall'
                                onClick={this.modalShow('delete', data.row._original)}
                                className='control-button'
                            >
                                <Glyphicon glyph='minus'/>
                            </Button>
                        )
                }

                return (
                    <Row className='text-center'>
                        {rowData}
                    </Row>
                )
            }
        });


        return itemArr;
    }

    modalshow_commonInit() {
        this.setState({
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load" : [],
                "floor_load" : []
            }
        });
    };

    common_buttondisabledLengthCheck = (param,switchdata) => {
        switch (switchdata)
        {
            case `push`:
                if(this.state.buttondisabledArr[param].length === 0)
                {
                    this.state.buttondisabledArr[param].push("dataset");
                }
            break;
            case `pop`:
                this.state.buttondisabledArr[param].pop();
            break;
            default:
                console.log("common_buttondisabledLengthCheck_switchErr");
            break;
        }
    }

    modalShow = (modalType, param) => async event => {
        try {
            event.preventDefault()

            this.floor_load_flag = false;

            this.modalshow_commonInit();

            let setData = {
                outbound_reject_id:  param && param.id ? param.id : '',
                company_id:          param && param.cm12_companies && param.cm12_companies.id ? param.cm12_companies.id : '',
                company_name:        param && param.cm12_companies && param.cm12_companies.company_name ? param.cm12_companies.company_name : '',
                floor_flg:           param && param.cm12_companies  && param.cm12_companies.floor_flg ? param.cm12_companies.floor_flg === "Y" : null,
                department_id:       param && param.cm13_departments && param.cm13_departments.id ? param.cm13_departments.id : '',
                department_name:     param && param.cm13_departments && param.cm13_departments.department_name ? param.cm13_departments.department_name : '',
                department_prefix:   param && param.cm13_departments && param.cm13_departments.department_prefix ? param.cm13_departments.department_prefix: '',
                floor_id:            param && param.cm13_departments && param.cm13_departments.id ? param.cm13_departments.id : '',
                floor_name:          param && param.cm13_departments && param.cm13_departments.floor_name ? param.cm13_departments.floor_name: '',
                all_department_flag: !!(param && (param.all_department_flag === "Y")),
                telno:               param && param.telno ? param.telno : '',
                memo:                param && param.memo ? param.memo : '',
                csv_outbound_reject: [],
                csv_header:          ''
            }


            // 新規作成時にcompany以下なら会社固定
            if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                setData.company_id = this.props.userInfo.company_id
                setData.company_name = this.props.userInfo.company_name
                setData.floor_flg = this.props.userInfo.floor_flg
            }
            // 新規作成時にdepartment以下なら拠点固定
            if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)) {
                if (this.props.userInfo.floor_flg) {
                    setData.department_id = this.props.userInfo.parent_department_id
                    setData.department_name = this.props.userInfo.parent_department_name
                    setData.department_prefix = this.props.userInfo.department_prefix
                } else {
                    setData.department_id = this.props.userInfo.department_id
                    setData.department_name = this.props.userInfo.department_name
                }
            }
            // 新規作成時にfloor以下ならフロア固定
            if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)) {
                setData.floor_id = this.props.userInfo.department_id
                setData.floor_name = this.props.userInfo.floor_name
            }

            if (modalType === "insertBatch") {
                const template_header = await this.ascAxios(
                    "post", `${this.reactContainerPath}/getTemplateHeader`
                );
                setData.csv_header = template_header.data;
            }

            // 追加確認ポップアップ表示設定
            setData.isSetShowAddingConfirmationPopup =
            setData.company_id !== ""
                ? await this.getIsShowAddingConfirmationPopup(setData.company_id)
                : false
            ;

            this.setState(setData)

            this.getCompanySelect()
            this.getDepartmentSelect(setData)
            this.getFloorSelect(setData);

            this.setState({
                show: true,
                modalType,
                showConfirm: false, 
                confirmMemo: "", 
                confirmValue: ""
            })
        } catch (err) {
            alert(this.getErrorString(err.response.data));
        }
    }

    async onSelectChange (event, param) {
        super.onSelectChange(event, param);
        let value = (event && event.value) ? event.value : "";
        let floor_flg = (event && event.floor_flg) ? event.floor_flg === "Y" : null;
        let department_prefix = (event && event.department_prefix) ? event.department_prefix : "";

        try{
            if (param === "company_id") {
                this.setState({
                    department_id: '',
                    floor_id: '',
                    floor_flg,
                    csv_outbound_reject: [],
                    csv_line: 0
                });
                this.getDepartmentSelect({company_id: value, floor_flg});
                this.getFloorSelect({
                    company_id: this.state.company_id,
                    department_prefix,
                    floor_flg});
                this.setState({
                    isSetShowAddingConfirmationPopup: await this.getIsShowAddingConfirmationPopup(value)
                });
            } else if (param === "department_id") {
                this.floor_load_flag = true;
                this.setState({floor_id: ''});
                this.getFloorSelect({
                    company_id: this.state.company_id,
                    department_prefix,
                    floor_flg: this.state.floor_flg
                });
            }
        }catch(err){
            console.log(err);
            this.showErrorObjectMesssage(err);
        }
    }

    onCheckBoxChange (event, param) {
        super.onCheckBoxChange(event, param);
        if (param === "all_department_flag") {
            this.setState({
                department_id: '',
                floor_id: '',
            });
        }
    }

    getCompanySelect = () => {
        this.ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath})
            .then(res => {
                this.common_buttondisabledLengthCheck(`company_id`,`push`);
                this.setState({
                    companySelect: res.data
                })
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data))
            })
    }

    getDepartmentSelect = ({company_id, floor_flg}) => {
        if(company_id) {
            this.common_buttondisabledLengthCheck(`department_load`,`push`);
        } else {
            this.common_buttondisabledLengthCheck(`department_load`,`pop`);
        }
        this.ascAxios('post', `Common/departmentSelect`, {
            container: this.reactContainerPath,
            company_id,
            floor_flg
        }).then(res => {
            if (this.state.modalType === "update" && floor_flg && this.state.department_id && this.state.department_prefix) {
                let my_prefix = this.state.department_prefix.slice(0, 2);
                res.data.forEach(row => {
                    if (row.department_prefix && my_prefix === row.department_prefix) {
                        this.setState({department_id: row.value});
                    }
                });
            }
            if(this.state.company_id) {
                this.common_buttondisabledLengthCheck(`department_id`,`push`);
                this.common_buttondisabledLengthCheck(`department_load`,`pop`);
            } else {
                this.common_buttondisabledLengthCheck(`department_id`,`pop`);
            }
            this.setState({departmentSelect: res.data})
        }).catch(err => {
            alert(this.getErrorString(err.response.data))
        })
    }

    getFloorSelect = ({company_id, department_prefix, floor_flg}) => {
        if(this.floor_load_flag === true && department_prefix && company_id)
        {
            this.common_buttondisabledLengthCheck(`floor_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
        }
        if (floor_flg) {
            this.ascAxios('post', `Common/floorSelect`, {company_id, department_prefix})
            .then(res => {
                if(this.state.department_id) {
                    this.common_buttondisabledLengthCheck(`floor_id`,`push`);
                    this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
                    this.floor_load_flag = false;
                } else {
                    this.common_buttondisabledLengthCheck(`floor_id`,`pop`);
                }
                this.setState({
                    floorSelect: res.data
                })
            }).catch(err => {
                alert(this.getErrorString(err.response.data))
            })
        }
    }

    onClickHandle = (modalType) => async event => {
        let {
            outbound_reject_id,
            company_id,
            department_id,
            floor_id,
            all_department_flag,
            telno,
            memo,
            isSetShowAddingConfirmationPopup,
            csv_outbound_reject,
            confirmMemo
        } = this.state;

        // 追加確認ポップアップの表示条件チェック
        if (
            this.isTargetShowAddingConfirmationPopup &&
            isSetShowAddingConfirmationPopup
        ) {
            // 追加確認ポップアップを表示すべき場合
            if (!this.state.showConfirm) {
                // 初回ボタン押下時：追加確認ポップアップを表示
                this.onClickConfirm(event, true);
                return;
            }
        } else {
            // 追加確認ポップアップ表示設定がOFFである場合、
            // 通常の確認ポップアップを表示
            let confirmItem = this.getConfirmKeyItem(modalType);
            if (modalType === 'insertBatch') {
                confirmItem = csv_outbound_reject.length-1;
                console.log(confirmItem);
            }
            if (!window.confirm(`${this.createPopupMessage(
                this.props.langText.Body.OutboundRejectRule,
                confirmItem,
                modalType
            )}`)) {
                return;
            }
        }

        switch (modalType) {
            case 'insert':
                try {
                    this.blockUI();
                    const insert_result = await this.ascAxios(
                        "post", `${this.reactContainerPath}/insert`, {
                            company_id,
                            department_id: floor_id || department_id,
                            all_department_flag,
                            telno,
                            memo,
                            confirmMemo,
                            isSetShowAddingConfirmationPopup
                    });
                    if (insert_result.data) {
                        alert(this.props.langText.Message.DataInsertSuccess);
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                } catch (err) {
                    alert(this.getErrorString(err.response?.data || err));
                    if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                }
                break;
            case 'insertBatch':
                try {
                    this.blockUI();

                    const insert_batch_result = await this.ascAxios(
                        'post', `${this.reactContainerPath}/insertBatch`, {
                            company_id,
                            files: csv_outbound_reject,
                            department_id,
                            floor_id,
                            all_department_flag,
                            confirmMemo
                        });
                        if (insert_batch_result.data) {
                            let message = [];
                        message.push(
                            this.sprintf(
                                this.props.langText.Message.SuccessDataCount, insert_batch_result.data.count
                            ));
                        message.push(
                            this.sprintf(
                                this.props.langText.Message.FailedDataCount, insert_batch_result.data.err.count
                            ));
                        let err_body = insert_batch_result.data.err.err_body;
                        if (err_body) {
                            for(let code in err_body){
                                if(err_body[code].length > 0){
                                    message.push(this.getErrorString({code: `OutboundReject_${code}`}));
                                    err_body[code].forEach(row => {
                                        message.push(
                                            `${this.sprintf(this.props.langText.Message.Line, row.line+1)}${row.data}`
                                        );
                                    })
                                }
                            }
                        }

                        
                        if (insert_batch_result.data.err.count) {
                            this.setState({
                                errorMessageModalShow: true,
                                errText: message.join("\r\n")
                            });
                        } else {
                            alert(message.join("\r\n"));
                        }

                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                } catch (err) {
                    alert(this.getErrorString(err.response?.data || err));
                    if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                }
                break;
            case 'update':
                try {
                    this.blockUI();
                    const update_result = await this.ascAxios(
                        'post', `${this.reactContainerPath}/update`, {
                            outbound_reject_id,
                            company_id,
                            department_id: floor_id || department_id,
                            all_department_flag,
                            telno,
                            memo,
                            confirmMemo,
                            isSetShowAddingConfirmationPopup
                    });
                    if (update_result.data) {
                        alert(this.props.langText.Message.DataUpdateSuccess);
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                } catch (err) {
                    alert(this.getErrorString(err.response?.data || err));
                    if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                }
                break;
            case 'delete':
                try {
                    this.blockUI();
                    const delete_result = await this.ascAxios(
                        'post', `${this.reactContainerPath}/delete`, {
                            outbound_reject_id,
                            company_id,
                            department_id,
                            all_department_flag,
                            telno,
                            confirmMemo,
                            isSetShowAddingConfirmationPopup
                    });
                    if (delete_result.data) {
                        alert(this.props.langText.Message.DataDeleteSuccess);
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                } catch (err) {
                    alert(this.getErrorString(err.response?.data || err));
                    if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    }
                }
                break;
            default:
                alert(this.getErrorString({code: 'modal'}));
                this.setState({
                    show: false,
                    showConfirm: false,
                    confirmMemo: "",
                    confirmValue: ""
                });
                break;
        }

        // 最終的なBlockUIの解除
        this.unblockUI();
    }



    validationHandle = param => {
        let nowState = null

        let {
            company_id, 
            department_id, 
            floor_id, 
            all_department_flag,
            telno,
            csv_outbound_reject,
            csv_line,
        } = this.state;

        // set ideal telno format => + at beginning and * at end are optional, numbers 1-19 digits
        let validTelno = /^[+]?([0-9]{1,19})[*]?$/

        switch (param) {
            case 'company_id':
                nowState = this.state[param] ? null : 'error'
                break

            case 'department_id':
                nowState = (this.state.department_id || this.state.all_department_flag) ? null : 'error'
                break

            case 'floor_id':
                nowState = (this.state.floor_id || this.state.all_department_flag) ? null : 'error'
                break

            case 'telno':
                nowState = (validTelno.test(this.state[param])) ? null : 'error'
                break

            case 'insert':
            case 'update':
            case 'delete':
                nowState = (
                       company_id
                    && (department_id || all_department_flag)
                    && (floor_id || all_department_flag || !this.state.floor_flg)
                    && validTelno.test(telno)
                    )
                break;

            case "insertBatch":
                nowState = (
                    company_id 
                    && (department_id || all_department_flag)
                    && (floor_id || all_department_flag || !this.state.floor_flg) 
                    && (csv_outbound_reject.length && 
                        csv_line <= (GlobalConst.CSV_IMPORT_SIZE_LIMIT.outBound + 1))
                    )
                break;

            default:
        }

        return nowState
    }

    templateDownload = async (btn) => {
        try {
            let btnvalue = btn.target.value;
            const template_result = await this.ascAxios(
                'post',`Download/contentDL`, {param:btnvalue}
            );
            let templateURL = template_result.data.url;
            window.location.href=templateURL;

            // アクセスログ保存
            this.saveAccessLogs({
                "resource" : `/OutboundReject/contentDL`,
                "body" : {
                    "template_type" : btnvalue,
                    "download_url" : templateURL
                }
            });
        } catch (err) {
            alert(this.getErrorString(err));
        }
    };

    /**
     * CSVファイルをアップロードまたはドラッグした際の読み込み処理
     * @param {} data
     */
    handleOnDrop = (data, file) => {
        //ファイル名チェック
        if (!file.name.match(/.csv$/i)) {
            this.showErrorObjectMesssage("CsvTypeError");
            return false;
        }

        if (data.length > (GlobalConst.CSV_IMPORT_SIZE_LIMIT.outBound + 1)) {
            this.showErrorObjectMesssage("OutboundReject_Upload_SizeLimit");
            this.setState({ csv_outbound_reject: false });
            return false;
        } 
        
        const reader = new FileReader();
        reader.readAsText(file, 'SHIFT-JIS');
        reader.onload = (e) => {
            let csv_line = e.target.result.split(/\r\n/);
            let csv_arr = [];
            csv_line.forEach(row => {
                if (row.length > 0) {
                    csv_arr.push(row.split(","));
                }
            });

            if (csv_arr[0].join(',') !== this.state.csv_header) {
                this.showErrorObjectMesssage("OutboundReject_HeaderError");
                this.setState({ csv_outbound_reject: false });
                return false;
            } else if (csv_arr.length < 2) {
                this.showErrorObjectMesssage("OutboundReject_CsvNoContent");
                return false;
            } else {
                this.setState({ 
                    csv_outbound_reject: csv_arr,
                    csv_line: data.length
                });
            }
        }
    };

    /**
     * CSVファイルのエラー処理
     */
    handleOnError = () => {
        this.setState({csv_outbound_reject: false});
    };

    /**
     * アップロード済みのCSVファイルの削除処理
     */
    handleOnRemoveFile = () => {
        this.setState({csv_outbound_reject: false});
    };
    
    /**
     * 確認ポップアップのキーアイテムを生成
     * @param {string} modalType 
     * @returns {string} 確認ポップアップで表示するキーアイテム
     */
    getConfirmKeyItem = (modalType) => {
        if (modalType === 'insertBatch' && this.state.csv_outbound_reject && this.state.csv_outbound_reject.length > 1) {
            // 一括登録の場合：テーブル表示用の配列形式でデータを返す
            const maxDisplayLimit = 5;
            const totalDataRows = this.state.csv_outbound_reject.length - 1; // ヘッダー行を除いたデータ行数
            const displayCount = Math.min(totalDataRows, maxDisplayLimit);
            
            // テーブル表示用の配列：[0]がヘッダー、[1]以降がデータ行
            let displayArray = [];
            
            // ヘッダー（テーブルのth部分）を設定 - 言語ファイルから取得
            const headerName = this.props.langText.Body.Telno;
            displayArray.push(headerName);

            // CSVデータから電話番号を取得（ヘッダー行をスキップして、index 1から開始）
            for (let i = 1; i <= displayCount; i++) {
                if (this.state.csv_outbound_reject[i] && this.state.csv_outbound_reject[i].length > 0) {
                    const phoneNumber = this.state.csv_outbound_reject[i][0]; // 最初の列が電話番号
                    displayArray.push(phoneNumber);
                }   
            }
            
            // データ行数が5件を超える場合は「他n件」を追加
            if (totalDataRows > maxDisplayLimit) {
                const remainingCount = totalDataRows - maxDisplayLimit;
                const otherCountText = this.props.langText.Body.OtherCount.replace('{0}', remainingCount);
                displayArray.push(otherCountText);
            }

            return displayArray;
        } else {
            // 通常の登録・更新・削除の場合
            return this.state.telno;
        }
    }

    render() {
        return (
            <div className='OutboundReject'>
                <Row>
                    {
                        this.props.currentPermission.create
                        &&
                        <Col xs={12} md={12}>
                            <Button
                                id="outboundReject-insert"
                                className='table-button'
                                bsStyle='default'
                                bsSize='sm'
                                onClick={this.modalShow('insert')}
                            >
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                            <Button
                                id="outboundReject-insertBatch"
                                className='table-button'
                                bsStyle='default'
                                bsSize='sm'
                                onClick={this.modalShow('insertBatch')}>
                                {this.props.langText.Body.InsertBatchTitle}
                            </Button>
                            

                        </Col>
                    }
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = 'manual'
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable = {true}
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}
                        />
                    </Col>
                </Row>

                <OutboundRejectModal
                    state = {this.state}
                    propSetState = {this.propSetState}
                    langText = {this.props.langText}
                    charaLimit = {this.props.charaLimit}
                    onClick = {this.onClickHandle}
                    onClickConfirm = {this.onClickConfirm}
                    onTextChange_Limit = {this.onTextChange_Limit}
                    onSelectChange = {this.onSelectChange}
                    onMultiSelectChange = {this.onMultiSelectChange}
                    onCheckBoxChange = {this.onCheckBoxChange}
                    onRadioChange = {this.onRadioChange}
                    getScopeGreaterEqual = {this.getScopeGreaterEqual}
                    validationHandle = {this.validationHandle}
                    templateDownload={this.templateDownload}
                    handleOnDrop={this.handleOnDrop}
                    handleOnError={this.handleOnError}
                    handleOnRemoveFile={this.handleOnRemoveFile}
                    isTargetShowAddingConfirmationPopup = {this.isTargetShowAddingConfirmationPopup}
                    />

                {(
                    this.isTargetShowAddingConfirmationPopup &&
                    this.state.isSetShowAddingConfirmationPopup &&
                    <AscConfirm
                        state={
                            {
                                ...this.state,
                                show: this.state.showConfirm || false // showConfirmをshowに変換
                            }
                        }
                        key={this.state.modalType} // modalTypeが変更されたときに強制的に再マウント
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        onClick = {this.onClickHandle}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        confirmKey = {this.props.langText.Body.OutboundRejectRule}
                        confirmKeyItem = {this.getConfirmKeyItem(this.state.modalType)}
                        sprintf = {this.sprintf}
                        customBtn1Func = {this.onClickConfirm}
                    />
                )}
            </div>
        )
    }
}